import type { ComponentPropsWithRef, ReactNode } from "react";
import { cn } from "../../lib/cn";

export interface CenterProps extends ComponentPropsWithRef<"div"> {
  /** Mode d'affichage ("flex" ou "inline"). Par défaut "flex". */
  inline?: boolean;
  children?: ReactNode;
}

/**
 * Composant de centrage absolu/relatif SOTA.
 * Centre horizontalement et verticalement son contenu.
 */
export function Center({ className, inline = false, children, ...props }: CenterProps) {
  return (
    <div
      className={cn(
        inline ? "inline-flex" : "flex",
        "items-center justify-center text-center",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
